/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getGenericTokenIframe } from '../../store/dashboardHl/actions';
import { changeTitleBanner } from '../../store/actions';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import usePageTitle from '../../common/hooks/usePageTitle';
import { getNameClient } from '../../helpers/nameClient';

const GenericHollistics = (props: any) => {
    const dispatch = useDispatch();
    const PageTitleRolM = usePageTitle(props.location.pathname);
    const { id } = useParams<any>();

    const { token } = useSelector((state: any) => ({ token: state.DashboardHL.token }));
    const [urlState, setURLState] = useState<any>();
    const [state, setState] = useState<any>({
        currentHollistic: undefined
    });

    const extractDataJson = (jsCode: any, dataRegex: RegExp) => {
        const match = dataRegex.exec(jsCode);
        if (match && match[1]) {
            return JSON.stringify(eval('(' + match[1] + ')'))
        } else {
            return {}
        }
    }

    useEffect(() => {
        if (token && state.currentHollistic) {
            let url = state.currentHollistic?.URL;
            if (!url.endsWith('/')) url = url + '/';
            const identificator = state.currentHollistic?.holisticsClientIdentificator;

            setURLState(url + identificator + "?_token=" + token);
        }

    }, [token, state.currentHollistic]);
    useEffect(() => {
        const permissions = JSON.parse(String(localStorage.getItem('permisos')));
        const currentHollistic = permissions.find((item: any) => item.id == id);

        if (currentHollistic && currentHollistic.identificator === "Holistics") {
            const formatFilters = extractDataJson(
                currentHollistic.JSONHollistics,
                /var\s+filters\s*=\s*({[\s\S]*?});/
            );
            const formatPermissions = extractDataJson(
                currentHollistic.JSONHollistics,
                /var\s+permissions\s*=\s*({[\s\S]*?});/
            );
            dispatch(getGenericTokenIframe({
                secretKey: currentHollistic.clientSecret,
                filters: formatFilters,
                permissions: formatPermissions
            }));
            dispatch(changeTitleBanner(currentHollistic.nombre));
            setState({ ...state, currentHollistic });
        } else {
            dispatch(changeTitleBanner("No valid Hollistics select"));
        }
    }, [id]);
    return (
        <React.Fragment>
            <PageTitle>
                <title>{PageTitleRolM.replace(/-/g, ' ')} | {getNameClient()}</title>
            </PageTitle>
            {state.currentHollistic && urlState ?
                (<iframe
                    data-v-9b74a260=""
                    src={`${urlState}`}
                    className="embedded-dashboard-iframe h-[800px] w-full"
                    frameBorder="0"
                    allowFullScreen={true}
                    width="100%"
                    height="900px"
                    style={{ marginTop: '60px' }}
                ></iframe>) :
                <div className='pt-5 mt-5'>
                    <div className='d-flex justify-content-center align-items-center'>
                        <div>
                            <i style={{ fontSize: 150 }} className={`bx bx-error`}></i>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
};

export default GenericHollistics;
